<div class="mfa-verify-container">
  <div class="verify-card">
    <div class="card-header">
      <i class="fas fa-shield-alt"></i>
      <h2>多因素認證</h2>
      <p>請輸入您的驗證器應用程式顯示的 6 位數驗證碼</p>
    </div>

    <div class="card-body">
      <!-- Loading State -->
      <div *ngIf="loading" class="loading-state">
        <div class="spinner"></div>
        <p>驗證中，請稍候...</p>
      </div>

      <!-- Error State -->
      <div *ngIf="error && !loading" class="error-message">
        <i class="fas fa-exclamation-triangle"></i>
        <span>{{ error }}</span>
      </div>

      <!-- Attempt Warning -->
      <div *ngIf="showAttemptWarning && !loading" class="warning-message">
        <i class="fas fa-exclamation-circle"></i>
        <span>剩餘嘗試次數：{{ remainingAttempts }}</span>
      </div>

      <!-- Blocked State -->
      <div *ngIf="isBlocked" class="blocked-message">
        <i class="fas fa-ban"></i>
        <span>驗證失敗次數過多，請稍後再試</span>
      </div>

      <!-- Verification Form -->
      <div *ngIf="!loading && !isBlocked" class="verification-form">
        <form [formGroup]="verificationForm" (ngSubmit)="onVerify()">
          <div class="form-group">
            <label for="verificationCode">驗證碼</label>
            <input type="text" 
                   id="verificationCode"
                   class="form-control verification-input"
                   formControlName="verificationCode"
                   placeholder="請輸入 6 位數驗證碼"
                   maxlength="6"
                   autocomplete="off"
                   (input)="onInputChange()">
            
            <div *ngIf="verificationForm.get('verificationCode')?.invalid && verificationForm.get('verificationCode')?.touched" 
                 class="error-text">
              請輸入有效的 6 位數驗證碼
            </div>
          </div>
          
          <div class="button-group">
            <button type="submit" 
                    class="btn btn-primary"
                    [disabled]="verificationForm.invalid || loading">
              <i class="fas fa-check"></i>
              驗證
            </button>
            
            <button type="button" 
                    class="btn btn-secondary"
                    (click)="onCancel()"
                    [disabled]="loading">
              <i class="fas fa-times"></i>
              取消
            </button>
          </div>
        </form>
      </div>

      <!-- Help Text -->
      <div *ngIf="!loading && !isBlocked" class="help-text">
        <p>
          <i class="fas fa-info-circle"></i>
          請從您的驗證器應用程式（如 Google Authenticator、Microsoft Authenticator）中找到對應的 6 位數驗證碼。
        </p>
        <p>
          如果您無法存取驗證器應用程式，請聯繫系統管理員。
        </p>
      </div>
    </div>
  </div>
</div>